import React from 'react';
import { IoIosCloseCircle } from 'react-icons/io';
import { RiCloseFill } from 'react-icons/ri';
import './alert/alertmodal.css';
export function ErrorAlert({ message, onClose }) {
  return (
    <div>
      <div className='overlay'>
        <div
          className='popupWarning d-flex justify-content-between  align-items-center'
          style={{
            backgroundColor: '#eec8c5',
            borderWidth: 2,
            borderColor: '#c08482',
          }}
        >
          <div className='d-flex justify-content-start'>
            <div className='alert_modal-header d-flex align-items-center input_item justify-content-center'>
              <IoIosCloseCircle size={40} fill='#b72c2b' />
            </div>
            <div style={{ paddingLeft: 10 }}>
              <div
                className='pb-0 mb-0'
                style={{ color: '#b72c2b', fontSize: 16 }}
              >
                {'ERROR!'}
              </div>
              <div style={{ lineHeight: 1, color: '#ce706f' }} className='  '>
                {message}
              </div>
            </div>
          </div>
          <div onClick={onClose} style={{ width: 30, height: 30 }}>
            <RiCloseFill size={25} color={'#ce706f'} />
          </div>
        </div>
      </div>
    </div>
  );
}
